import { render, staticRenderFns } from "./LandPurchase.vue?vue&type=template&id=f63de702&"
import script from "./LandPurchase.vue?vue&type=script&lang=js&"
export * from "./LandPurchase.vue?vue&type=script&lang=js&"
import style0 from "./LandPurchase.vue?vue&type=style&index=0&id=f63de702&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports